import { ChangeType } from "@zapier/checkout/esm/types";

export const getChangeLabel = (changeType: ChangeType) => {
  switch (changeType) {
    case "downgrade":
      return "Downgrade";
    case "upgrade":
      return "Upgrade";
    case "change":
      return "Update";
    default:
      return "";
  }
};
